var exports = {
  "k": "xe533113f--204edf--container",
  "X": "xe533113f--204edf--scroller",
};

module.exports = exports;
